import { FC } from 'react'
import { connect } from 'react-redux'
import { KpiOverviewPageComponent } from './KpiOverviewPageComponent'
import { State } from '../core/reducers'

interface Props {
  // 如果需要从Redux状态映射props，可以在这里定义
}

const mapStateToProps = (state: State) => ({
  // 映射需要的状态
})

const mapDispatchToProps = {
  // 映射需要的actions
}

export const KpiOverviewPageContainer: FC<Props> = connect(
  mapStateToProps,
  mapDispatchToProps
)(KpiOverviewPageComponent)

export default KpiOverviewPageContainer